export const debounce =
  (ms: number) =>
  <Fn extends (...args: any[]) => any>(fn: Fn): Fn => {
    let timeout: ReturnType<typeof globalThis.setTimeout> | undefined;
    const enhancedFn = ((...args) => {
      if (timeout) globalThis.clearTimeout(timeout);
      timeout = globalThis.setTimeout(() => fn(...args), ms);
    }) as Fn;
    return enhancedFn;
  };

export const noop = () => {};
